import { createContext, FC, ReactNode, useContext, useMemo } from 'react';

export interface DocumentPrintContextType {
    printMode: boolean;
}

const defaultDocumentPrintContext: DocumentPrintContextType = {
    printMode: false,
};

export const DocumentPrintContext = createContext<DocumentPrintContextType>(defaultDocumentPrintContext);

export interface IDocumentPrintProviderProps {
    children: ReactNode;
    printMode?: boolean;
}

export const DocumentPrintProvider: FC<IDocumentPrintProviderProps> = ({ children, printMode = false }) => {
    const contextValue = useMemo(() => ({ printMode }), [printMode]);

    return <DocumentPrintContext.Provider value={contextValue}>{children}</DocumentPrintContext.Provider>;
};

export const useDocumentPrint = () => {
    return useContext(DocumentPrintContext);
};
